export const firebaseConfig = {
  apiKey: "AIzaSyBFFks5c_hy9bLjir3_jAegeOYNqgt-API",
  authDomain: "ec-app-f17ae.firebaseapp.com",
  databaseURL: "https://ec-app-f17ae.firebaseio.com",
  projectId: "ec-app-f17ae",
  storageBucket: "ec-app-f17ae.appspot.com",
  messagingSenderId: "1096676214229",
  appId: "1:1096676214229:web:4a63c4272981c47562e95c",
  measurementId: "G-71BYSKBHT3"
};